<template>
  <div class="page page-center">
    <div class="container-tight py-4">
      <div class="empty">
        <div class="empty-header">AUTH</div>
        <p class="empty-title">正在登录...</p>
        <p class="empty-subtitle text-secondary">

        </p>
        <div class="empty-action">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { global } from '../global.js'
export default {
  name: 'AuthTokenPage',
  components: {},
  data() {
    return {
      global: global,
    };
  },
  methods: {
    auth: function () {
      // let cc = {
      //   token: "I9/ua9srQ/PLLRx+fD0gGQTGWyIzwbJB/WbpqHAtcMXDgHy/oRxHlKcp0btCjjCYCZ9gbE5zVqxnP8XDdXdSOMDYbzj82yMVJoucVLWJsxQnik1cRi+y6gScdzdDPlKW",
      //   url: "/home_assistant",
      // }
      // console.log("token", window.btoa(JSON.stringify(cc)));
      let pa = JSON.parse(window.atob(this.$route.params.token));
      if (pa.token != "") {
        global.userinfo = {
          'token': pa.token,
        };
        localStorage.setItem("userinfo", JSON.stringify(global.userinfo));
        global.postData("user/user_profile", {}, { token: true })
          .then(data => {
            if (data.code == 200) {
              global.userinfo = {
                'email': data.body.email,
                'telphone': data.body.telphone,
                'avatar': data.body.avatar,
                'nickname': data.body.nickname,
                'token': data.body.token,
              };
              localStorage.setItem("userinfo", JSON.stringify(global.userinfo));
              this.$router.push(pa.url);
            } else {
              global.showTips(data.msg);
            }
          });
      }
    }

  },
  created() {
    this.auth();
  },
}
</script>